export default __webpack_public_path__ + "static/media/new-icon.5bcb9250.svg";